import { SelectInput } from '@interstate/components/SelectInput';
import { useFlexBuyPercentField } from '@makemydeal/dr-dash-components';
import { DealTabs } from '@makemydeal/dr-shared-types';

import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { ScenarioRow } from '../../ScenarioRow';

export const FlexBuyPercentRow = () => {
    const { label, selectProps } = useFlexBuyPercentField({ tab: DealTabs.SUMMARY });
    const inputId = useScenarioCellId('flexBuyPercent');

    return (
        <ScenarioRow rowKey="flexBuyPercent" label={label} inputId={inputId}>
            <SelectInput {...selectProps} id={inputId} label={label} displayLabel={false} />
        </ScenarioRow>
    );
};
